/* eslint-disable */
exports.install = function (Vue, options) {
  Vue.directive('drag', {
    inserted: function (el) {
      let oDiv = el // 当前元素
      let parent = el.parentNode
      // let self = this // 上下文
      parent.style.position = 'absolute'
      parent.style.zIndex = 999
      parent.style.left = '50%'
      parent.style.transform = 'translate(-50%)'
      oDiv.onmousedown = function (e) {
        // 鼠标按下，计算当前元素距离可视区的距离
        let disX = e.clientX - parent.offsetLeft
        let disY = e.clientY - parent.offsetTop

        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          let l = e.clientX - disX
          let t = e.clientY - disY
          // song top小于-100时禁止拖动, 防止拖入屏幕上方
          // console.log(t)
          if (t > -100) {
            // 移动当前元素
            parent.style.left = l + 'px'
            parent.style.top = t + 'px'
          }
        }
        document.onmouseup = function (e) {
          document.onmousemove = null
          document.onmouseup = null
        }
      }
    }
  })
  // IP或网址是否合法
  Vue.prototype.validUrl = function (idValue) {
    let reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/
    if (reg.test(idValue)) {
      if (RegExp.$1 < 256 && RegExp.$2 < 256 && RegExp.$3 < 256 && RegExp.$4 < 256) {
        return true
      } else {
        return false
      }
    } else {
      // let domain = /^([\w-]+\.)+((com) | (net) | (org) | (gov\.cn) | (info) | (cc) | (com\.cn) | (net\.cn) | (org\.cn) | (name) | (biz) | (tv) | (cn) | (mobi) | (name) | (sh) | (ac) | (io) | (tw) | (com\.tw) | (hk) | (com\.hk) | (ws) | (travel) | (us) | (tm) | (la) | (me\.uk) | (org\.uk) | (ltd\.uk) | (plc\.uk) | (in) | (eu) | (it) | (jp))$/
      //let domain = /(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?/
      let domain = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/
      let flagDomain = domain.test(idValue)
      if (flagDomain) {
        return true
      } else {
        return false
      }
    }
  }
  // 判断是否包含字母
  Vue.prototype.includeLetters = function (str) {
    let reg = /[a-zA-Z]/
    if (reg.test(str)) {
      return true
    } else {
      return false
    }
  }
  // 是否为数字
  Vue.prototype.numberOnly = function (num) {
    let reg = /^[1-9]+[0-9]*]*$/
    if (reg.test(num)) {
      return true
    } else {
      return false
    }
  }
  // 判断密码-密码仅能为4-16位字母,数字,下划线的组合
  Vue.prototype.checkPassword = function (num) {
    let reg = /^\w{4,16}$/
    if (reg.test(num)) {
      return true
    } else {
      return false
    }
  }
  // 判断密码-长度8-16位字符，至少包含数字、大写字母、小写字母或特殊字符
  Vue.prototype.checkPassword2 = function (num) {
    // 大小写字母 + 数字 + 特殊字符 中的三种类型
    // let reg = /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/
    // 大小写字母 + 数字
    let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/
    if (reg.test(num)) {
      return true
    } else {
      return false
    }
  }
  // 正则-只能包含数字和分号;
  Vue.prototype.checkInput = function (num) {
    var reg = /^[0-9,;]+$/;
    if (reg.test(num)) {
      return true
    } else {
      return false
    }
  }
  // 是否包含中文
  Vue.prototype.isChineseChar = function (str) {
    let reg = /[\u4E00-\u9FA5\uF900-\uFA2D]/
    if (reg.test(str)) {
      return true
    } else {
      return false
    }
  }
  // 是否包含非法字符
  Vue.prototype.isNonlicetChar = function (str) {
    let reg = /[`~!@#$%^&*()+<>?:"{},.\/;'[\]]/
    if (reg.test(str)) {
      return true
    } else {
      return false
    }
  }
  // 邮件格式
  Vue.prototype.validEmail = function (num) {
    let reg = /^[a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+\.){1,63}[a-zA-Z0-9]+$/
    if (reg.test(num)) {
      return true
    } else {
      return false
    }
  }
  // 毫秒转化为 yyyy-MM-dd hh:mm:ss
  Vue.prototype.milsecondToFull = function (time) {
    let today = new Date(time)
    let yyyy = today.getFullYear()
    let MM = today.getMonth() < 9 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)
    let dd = today.getDate() < 10 ? '0' + today.getDate() : today.getDate()
    let HH = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
    let mm = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
    let ss = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
    return yyyy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
  }
  // 毫秒转化为 MM-dd hh:mm:ss
  Vue.prototype.milsecondToMDH = function (time) {
    let today = new Date(time)
    let MM = today.getMonth() < 9 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)
    let dd = today.getDate() < 10 ? '0' + today.getDate() : today.getDate()
    let HH = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
    let mm = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
    let ss = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
    return MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
  }
  // 毫秒转化为 hh:mm:ss
  Vue.prototype.milsecondToHMS = function (time) {
    let today = new Date(time)
    let HH = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
    let mm = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
    let ss = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
    return HH + ':' + mm + ':' + ss
  }
  // 毫秒转化为 hh:mm
  Vue.prototype.milsecondToHM = function (time) {
    let today = new Date(time)
    let HH = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
    let mm = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
    return HH + ':' + mm
  }
  // yyyy-mm-dd HH:mm:ss转化成毫秒
  Vue.prototype.fulltimeToSecond = function (a) {
    let time = new Date(a)
    let milisecond = time.getTime()
    return milisecond
  }
  // 毫秒转化为 yyyy-dd-MM
  Vue.prototype.milsecondToYYmmdd = function (time) {
    let today = new Date(time)
    let yyyy = today.getFullYear()
    let MM = today.getMonth() < 9 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)
    let dd = today.getDate() < 10 ? '0' + today.getDate() : today.getDate()

    return yyyy + '-' + MM + '-' + dd
  }
  // 毫秒转化为 yyyy-MM
  Vue.prototype.milsecondToYYmm = function (time) {
    let today = new Date(time)
    let yyyy = today.getFullYear()
    let MM = today.getMonth() < 9 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)

    return yyyy + '-' + MM
  }
  // 毫秒转化为 yyyy
  Vue.prototype.milsecondToYY = function (time) {
    let today = new Date(time)
    let yyyy = today.getFullYear()
    return yyyy
  }
  // yyyy-dd-MM转化为毫秒
  Vue.prototype.YYmmddToMilsecond = function (time) {
    let times = new Date(time)
    let milisecond = times.getTime()
    return milisecond
  }
  // 对象转化为Formdata
  Vue.prototype.parsetoFormdata = function (obj) {
    let arr = []
    for (let key in obj) {
      arr.push(key + '=' + obj[key])
    }
    let str = arr.join('&')
    return str
  }
  // 时间秒数转换 hh:mm:ss
  Vue.prototype.secToHHmmss = function (second) {
    let days = parseInt(second / (60 * 60 * 24))
    let hours = parseInt(second / (60 * 60) - days * 24)
    let minutes = parseInt(second / (60) - days * 24 * 60 - hours * 60)
    let seconds = parseInt(second - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60)
    hours = hours < 10 ? '0' + hours : hours
    minutes = minutes < 10 ? '0' + minutes : minutes
    seconds = seconds < 10 ? '0' + seconds : seconds
    return hours + ':' + minutes + ':' + seconds
  }
  // 时间秒数转换 dd hh:mm:ss
  Vue.prototype.secToDDhhmmss = function (second) {
    let days = parseInt(second / (60 * 60 * 24))
    let hours = parseInt(second / (60 * 60) - days * 24)
    let minutes = parseInt(second / (60) - days * 24 * 60 - hours * 60)
    let seconds = parseInt(second - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60)
    hours = hours < 10 ? '0' + hours : hours
    minutes = minutes < 10 ? '0' + minutes : minutes
    seconds = seconds < 10 ? '0' + seconds : seconds
    if (days > 0) {
      return days + this.$t('min_day') + hours + this.$t('report_park_hour') + minutes + this.$t('report_park_minute') + seconds + this.$t('report_park_second')
    } else {
      return hours + this.$t('report_park_hour') + minutes + this.$t('report_park_minute') + seconds + this.$t('report_park_second')
    }
  }
  // hh:mm:ss转换为秒数
  Vue.prototype.HHmmssTosec = function (hhmmss) {
    let secArr = hhmmss.split(':')
    let second = parseInt(secArr[0]) * 3600 + parseInt(secArr[1]) * 60 + parseInt(secArr[2])
    return second
  }
  // 时间秒数转换 hh:mm
  Vue.prototype.secToHHmm = function (second) {
    let hour = parseInt(second / 3600)
    let hourStr = hour
    if (hour < 10) {
      hourStr = '0' + hour
    }
    let minute = parseInt((second % 3600) / 60)
    let minStr = minute
    if (minute < 10) {
      minStr = '0' + minute
    }
    return hourStr + ':' + minStr
  }
  // 时间 hh:mm转换秒数
  Vue.prototype.HMtoSecond = function (time) {
    let secArr = time.split(':')
    let second = parseInt(secArr[0]) * 3600 + parseInt(secArr[1]) * 60
    return second
  }
  // "0,86340,0,86340"转换为 00:00-23:59,00:00-23:59
  Vue.prototype.strSecToHHmm = function (strSec) {
    let temp = strSec.split(',')
    return this.secToHHmm(temp[0] * 1) + '-' + this.secToHHmm(temp[1] * 1) + ',' + this.secToHHmm(temp[2] * 1) + '-' + this.secToHHmm(temp[3] * 1)
  }
  // hh:mm转换成秒 返回 00，60，00，60
  Vue.prototype.hhmmToSecond = function (a, b, c, d) {
    let start1 = hmToS(a)
    let end1 = hmToS(b)
    let start2 = hmToS(c)
    let end2 = hmToS(d)

    function hmToS(x) {
      let secArr = x.split(':')
      let second = parseInt(secArr[0]) * 3600 + parseInt(secArr[1]) * 60
      return second
    }
    return start1 + ',' + end1 + ',' + start2 + ',' + end2
  }
  // 比较两个日期是否为同一天
  Vue.prototype.isSameDay = function (date1, date2) {
    let date_1 = new Date(date1)
    let date_2 = new Date(date2)
    let y1 = date_1.getFullYear()
    let y2 = date_2.getFullYear()
    let m1 = date_1.getMonth()
    let m2 = date_2.getMonth()
    let d1 = date_1.getDate()
    let d2 = date_2.getDate()
    if (y1 === y2 && m1 === m2 && d1 === d2) {
      return true
    } else {
      return false
    }
  }
  // 一年后的今天
  Vue.prototype.oneYearLater = function (time) {
    let today = new Date(time)
    let endYY = today.getFullYear()
    let endMM = today.getMonth() < 9 ? '0' + today.getMonth() : today.getMonth()
    let endDD = today.getDate() < 10 ? '0' + today.getDate() : today.getDate()
    return (parseInt(endYY) + 1) + '-' + (parseInt(endMM) + 1) + '-' + endDD
  }
  // 判断日期是否有效
  Vue.prototype.isDateValid = function (a, b) {
    let start = this.fulltimeToSecond(a)
    var end = this.fulltimeToSecond(b)
    let time = (end - start) / 24 / 60 / 60 / 1000
    return time
  }
  // 车辆颜色
  Vue.prototype.colorToName = function (a) {
    let color
    if (a === 1) {
      color = this.$t('vehicle_colorBlue')
    } else if (a === 2) {
      color = this.$t('vehicle_colorYellow')
    } else if (a === 3) {
      color = this.$t('vehicle_colorBlack')
    } else if (a === 4) {
      color = this.$t('vehicle_colorWhite')
    } else if (a === 5) {
      color = this.$t('vehicle_colorGreen')
    } else if (a === 6) {
      color = this.$t('vehicle_colorKelly')
    } else if (a === 9) {
      color = this.$t('vehicle_colorOther')
    } else {
      color = this.$t('vehicle_colorOther')
    }
    return color
  }
  // ADAS报警转换
  Vue.prototype.adasToText = function (as) {
    let text
    switch (as) {
      case 0:
        text = this.$t('report_alarm_close_eyes')
        break
      case 1:
        text = this.$t('report_alarm_yawn')
        break
      case 3:
        text = this.$t('adas_drink_water')
        break
      case 5:
        text = this.$t('report_alarm_phone')
        break
      case 8:
        text = this.$t('report_alarm_smoking')
        break
      case 10:
        text = this.$t('adas_without_driver')
        break
      case 1001:
        text = this.$t('adas_FCW')
        break
      case 1002:
        text = this.$t('adas_HMW')
        break
      case 1003:
        text = this.$t('adas_VB')
        break
      case 1004:
        text = this.$t('adas_LDW_L')
        break
      case 1005:
        text = this.$t('adas_LDW_R')
        break
    }
    return text
  }
  // 根据合约期和合约开始日计算合约到期日
  Vue.prototype.endConstractTime = function (start, period) {
    console.log(start)
    console.log(period)
    let startTime = start.split('-')
    let startYear = startTime[0]
    let startMonth = startTime[1]
    let startDate = startTime[2]
    let month = parseInt(startMonth) + parseInt(period)
    let addYear = 0;
    if (month === 12) {
      addYear = 0;
    } else if (month === 24) {
      addYear = 1;
    } else {
      addYear = parseInt(month / 12);
    }
    let newMon = month % 12
    let newDate = parseInt(startDate) - 1
    if (start === undefined || period === undefined || period === '') {
      return ''
    }
    if (parseInt(startDate) === 1) {
      newMon = (month % 12) - 1
      if (parseInt(newMon) === 1 || parseInt(newMon) === 3 || parseInt(newMon) === 5 || parseInt(newMon) === 7 || parseInt(newMon) === 8 || parseInt(newMon) === 10 || parseInt(newMon) === 12) {
        newDate = 31
      } else if (parseInt(newMon) === 4 || parseInt(newMon) === 6 || parseInt(newMon) === 9) {
        newDate = 30
      } else if (parseInt(newMon) === 2) {
        newDate = 28
      } else if (parseInt(newMon) === -1) {
        // 即开始月份+合约期限,是12的整数倍
        if (parseInt(startDate) === 1) {
          newMon = 11
          newDate = 30
        }
      }
    } else {
      newMon = (month % 12)
      if (parseInt(newMon) === 0) {
        // 即开始月份+合约期限,是12的整数倍;
        if (parseInt(startDate) === 1) {
          newMon = 11
          newDate = 30
        } else {
          newMon = 12
        }
      }
    }
    let endYear = parseInt(startYear) + addYear
    let endMonth = newMon < 10 ? '0' + newMon : newMon
    let endDate = newDate < 10 ? '0' + newDate : newDate
    return endYear + '-' + endMonth + '-' + endDate
  }
  // 判断编辑终端时的合约状态和欠费天数
  Vue.prototype.checkPayStatus = function (payBegin, payMonth, delayDay) { // 开始时间  已付月数  宽限天数
    // 合约状态
    let payStatus
    // 欠费天数
    let payOverDay
    // 已付时间
    let payMonthSec = this.YYmmddToMilsecond(this.GetNextMonthDay(payBegin, parseInt(payMonth)))
    // 宽限天数
    let delayDaySec = parseInt(delayDay) * 24 * 60 * 60 * 1000
    // 到期时间
    let endTime = payMonthSec + delayDaySec
    // 今天
    let today = this.YYmmddToMilsecond(new Date())

    /*
    if (endTime > today) { // 到期时间 > 今天 = 正常
      payStatus = this.$t('vehicle_normal')
      payOverDay = '0'
    } else { // 到期时间 < 今天  = 欠费
      payStatus = this.$t('vehicle_arrears')
      payOverDay = (today - endTime) / 86400000
      // 如果有小数,加1天
      if (String(payOverDay).indexOf(".") !== -1) {
        payOverDay = parseInt(payOverDay) + 1
      }
    }
    */
    // 合同状态
    if (endTime > today) { // 到期时间 > 今天 = 正常
      payStatus = this.$t('vehicle_normal')
    } else { // 到期时间 < 今天  = 欠费
      payStatus = this.$t('vehicle_arrears')
    }
    // 欠费天数
    if (payMonthSec > today) { // 已付时间 > 今天 = 正常
      payOverDay = '0'
    } else { // 已付时间 < 今天  = 欠费
      // payOverDay = (today - payMonthSec) / 86400000
      // TODO 欠费天数=当前时间-已付月数-宽限天数
      payOverDay = (today - payMonthSec - delayDaySec) / 86400000
      // 如果有小数,加1天
      if (String(payOverDay).indexOf(".") !== -1) {
        payOverDay = parseInt(payOverDay) + 1
      }
    }
    return payStatus + '-' + payOverDay
  }

   // 判断编辑终端时的合约状态和欠费天数
   Vue.prototype.checkPayStatus1 = function (dueDate) { // 开始时间  已付月数  宽限天数
    // 合约状态
    let payStatus
    // 欠费天数
    let payOverDay


    // 到期时间
    let endTime = this.YYmmddToMilsecond(dueDate) + 86400000
    // 今天
    let today = this.YYmmddToMilsecond(new Date())

    // 合同状态
    if (endTime > today) { // 到期时间 > 今天 = 正常
      payStatus = this.$t('vehicle_normal')
    } else { // 到期时间 < 今天  = 欠费
      payStatus = this.$t('vehicle_arrears')
    }
    // 欠费天数
    if (endTime > today) { // 已付时间 > 今天 = 正常
      payOverDay = '0'
    } else { // 已付时间 < 今天  = 欠费
      // payOverDay = (today - payMonthSec) / 86400000
      // TODO 欠费天数=当前时间-已付月数-宽限天数
      payOverDay = (today - endTime) / 86400000
      // 如果有小数,加1天
      if (String(payOverDay).indexOf(".") !== -1) {
        payOverDay = parseInt(payOverDay) + 1
      }
    }
    return payStatus + '-' + payOverDay
  }
  // 取往后多少个月的时间
  Vue.prototype.GetNextMonthDay = function (date, monthNum) {
    var dateArr = date.split('-');
    var year = dateArr[0]; //获取当前日期的年份
    var month = dateArr[1]; //获取当前日期的月份
    var day = dateArr[2]; //获取当前日期的日
    var days = new Date(year, month, 0);
    days = days.getDate(); //获取当前日期中的月的天数
    var year2 = year;
    var month2 = parseInt(month) + parseInt(monthNum);
    if (month2 > 12) {
        // 增加年数
        var yearPlus = parseInt((parseInt(month2) / 12))
        // 12的倍数, 减1年(24,36)
        year2 = parseInt(year2) + (parseInt(month2) % 12 == 0 ? yearPlus - 1 : yearPlus);
        month2 = parseInt(month2) % 12 == 0 ? 12 : parseInt(month2) % 12;
    }
    var day2 = day;
    var days2 = new Date(year2, month2, 0);
    days2 = days2.getDate();
    if (day2 > days2) {
        day2 = days2;
    }
    if (month2 < 10) {
        month2 = '0' + month2;
    }

    var t2 = year2 + '-' + month2 + '-' + day2;
    return t2;
  }
  // 字符(长时间2018-03-28）转换成时间
  Vue.prototype.dateStrDate2Date = function (str) {
    let reg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/
    let r = str.match(reg)
    if (r === null) {
      return false
    }
    let d = new Date(r[1], r[3] - 1, r[4])
    return d
  }
  // 判断是否正确的日期,格式：年-月-日
  Vue.prototype.dateCheckDateString = function (str) {
    let r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/)
    if (r === null) {
      return false
    }
    let d = new Date(r[1], r[3] - 1, r[4])
    return (d.getFullYear() === r[1] && (d.getMonth() + 1) === r[3] && d.getDate() === r[4])
  }
  // 相邻规定时间内点击不执行
  let time2 = [0]
  Vue.prototype.invokeOneTime = function (fn) {
    let t = new Date() // 当前时间
    let mili = t.getTime() // 当前时间毫秒数
    time2.push(mili)
    if (time2.length > 2) {
      time2.splice(0, 1) // 时间戳多余两项，去除前面的项
    }
    if ((time2[1] - time2[0]) > 300) {
      fn()
    }
  }
  // 获取当天日期 YYYY-MM-DD
  Vue.prototype.getTodayDate = function () {
    let date = new Date()
    let seperator1 = '-'
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let strDate = date.getDate()
    if (month >= 1 && month <= 9) {
      month = '0' + month
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = '0' + strDate
    }
    let currentdate = year + seperator1 + month + seperator1 + strDate
    return currentdate
  }
  // 报表导出数据
  Vue.prototype.exportDataBase = function (url, params, docName, callback) {
    let xhr = new XMLHttpRequest()
    xhr.open('POST', url, true)
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    xhr.responseType = 'blob'
    xhr.onload = function () {
      if (this.status === 200) {
        let data = this.response
        console.log(data)
        let blob = new Blob([data])
        const fileName = docName + '.xlsx'
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        // 释放URL 对象
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      }
      if (callback) {
        callback();
      }
    }
    xhr.send(Vue.prototype.param(params))
  }
  // 将对象属性转换为&连接的字符串
  Vue.prototype.param = function (data) {
    let url = ''
    for (var k in data) {
      let value = data[k] !== undefined ? data[k] : ''
      url += '&' + k + '=' + encodeURIComponent(value)
    }
    return url ? url.substring(1) : ''
  }
  flvjs.LoggingControl.addLogListener(function(type, str) {
    if (type =="yjw") {
      let devinfo = str.split(',');
      let errorType = devinfo[0];
      switch(errorType){
          case 'offline':
            console.log('下线--' + '设备号：' + devinfo[1] + ' 通道号：' + (devinfo[2]));
            break;
          case 'invalid':
            console.log('网络连接异常--' + '设备号：' + devinfo[1] + ' 通道号：' + (devinfo[2]));
            break;
      }
    }
  })
  // sleep 方法
  Vue.prototype.sleep = function (d) {
    for(var t = Date.now();Date.now() - t <= d;);
  }
  // valueAtBit 方法
  Vue.prototype.valueAtBit = function (num, bit) {
    return (num >> (bit - 1)) & 1;
  }
  //字符串转UTF-8
  Vue.prototype.str2utf8 = function (str) {
    return eval('\''+encodeURI(str).replace(/%/gm, '\\x')+'\'');
  },
  /*
  计算文字宽度
  text 需要计算宽度的文字 包括空格
  font 字体属性  比如  `12px sans-serif`
  */
  Vue.prototype.getTextWidth = function (text, font) {
    var canvas = document.createElement('canvas')
    var context = canvas.getContext('2d')
    context.font = font;
    // 计算文字宽度
    var metrics = context.measureText(text)
    return metrics.width;
  }
}



// WEBPACK FOOTER //
// ./src/common/method/method.js